import React from 'react';

import { FilterGroup, FilterLogic } from '../types';

import ProspectFiltersSelectDropdown from './prospect-filters-select-dropdown';

type IProps = {
  groupIndex: number;
  conditionIndex: number;
  logic: FilterLogic;
  onUpdateFilterGroupLogic: (logic: FilterLogic, groupIndex: number) => void;
  onApplyAiColEnrichmentAutoRunSettingsCondition: (filterGroups: FilterGroup[], autoRunCondition: any, autoRunConditionLogic: any) => void | null;
};

const ProspectFiltersConditionLogic: React.FC<IProps> = ({
  groupIndex,
  conditionIndex,
  logic,
  onUpdateFilterGroupLogic,
  onApplyAiColEnrichmentAutoRunSettingsCondition,
}) => {
  if (conditionIndex === 0) {
    return (
      <div className="prospect-filters-condition-logic">
        {onApplyAiColEnrichmentAutoRunSettingsCondition===null ? <p>Where</p> : <p>If</p>}
      </div>
    );
  }

  if (conditionIndex === 1) {
    const options = [
      {
        key: FilterLogic.AND,
        label: 'And',
      },
      {
        key: FilterLogic.OR,
        label: 'Or',
      },
    ];

    return (
      <div className="prospect-filters-condition-logic">
        <ProspectFiltersSelectDropdown
          className="filter-logic-select"
          selectClassName="filter-logic-dropdown"
          options={options}
          optionRenderer={(option) => <span>{option.label}</span>}
          selectedOptionKey={logic}
          selectedOptionRenderer={(option) => <span>{option.label}</span>}
          onChange={(option) =>
            onUpdateFilterGroupLogic(option.key, groupIndex)
          }
        />
      </div>
    );
  }

  return (
    <div className="prospect-filters-condition-logic">
      <p>{logic}</p>
    </div>
  );
};

export default ProspectFiltersConditionLogic;
